import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Input, Select, Form, message} from 'antd';
import {modal} from 'icsoc-antd-ex';
import tTalkingSkillActions from 'Actions/systemSetting/talkingSkill';

const {ModalSize} = modal;
const {Option} = Select;
const FormItem = Form.Item;
const formItemLayout = {labelCol: {span: 5}, wrapperCol: {span: 19}};

class ConfigModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
      isShow: '',
      userStr: '',
    };
  }

  // 点击确定
  handleSubmit = () => {
    const {
      configModalData: {id} = {},
      pageStatus,
      form: {validateFields},
      getTableList,
      setConfigModalVisible,
      talkingSkillActions,
    } = this.props;
    const {isShow} = this.state;
    const user = window.localStorage.getItem('user') || '{}';
    const vccId = JSON.parse(user).profile?.vcc_id;

    validateFields((err, values) => {
      if (!err) {
        const params = {
          ...values,
          id,
          vccId,
          enabled: 1,
        };
        if (isShow === 'ai') {
          params.user = `${values.applicationCode},${values.channelCode},0000`;
        }
        this.setState({
          confirmLoading: true,
        });
        talkingSkillActions
          .configTalkingSkill(params)
          .then(res => {
            const {payload: {code} = {}} = res || {};

            if (parseInt(code, 10) === 200) {
              setConfigModalVisible();
              message.success('操作成功！');
              getTableList({...pageStatus});
            }
          })
          .finally(() => {
            this.setState({
              confirmLoading: false,
            });
          });
      }
    });
  };

  // 改变nlp
  handleSelectChange = value => {
    const {
      form: {setFieldsValue},talkingSkillActions
    } = this.props;
    this.setState({isShow: value});
    if (value === 'ai') {
      setTimeout(() => {
        setFieldsValue({
          intro: '开场语',
        });
      }, 100);
    }
  };

  componentDidMount() {
    const {talkingSkillActions, configModalData, form} = this.props;
    // 保存ai应用和渠道初始值
    this.setState({
      userStr: configModalData.aiUser,
      isShow: configModalData.nlpType,
    });
    // 通过部门更新ai应用列表
    talkingSkillActions.getAiAppOptions().then(res => {
      // 通过选择了相应的ai应用 更新渠道列表
      const aiApps = res.payload.data;
      if (form.getFieldValue('applicationCode') !== '') {
        if (aiApps.length !== 0) {
          // 从ai列表里获取选中的ai应用的信息
          const app = aiApps.find(
            i => i.applicationCode === form.getFieldValue('applicationCode'),
          );
          if (app) {
            // 更新渠道列表
            talkingSkillActions.getAppChannelOptions(app.applicationId);
            form.resetFields('channelCode');
          }
        }
      }
    });
    // yunwen
    talkingSkillActions.getYunwenScenes();
    talkingSkillActions.getYunwenChannels();
  }

  // 更改ai应用
  applicationChange = v => {
    const {talkingSkillActions, aiAppOptions} = this.props;
    if (aiAppOptions) {
      if (v !== '') {
        const app = aiAppOptions.find(i => i.applicationCode === v);
        talkingSkillActions.getAppChannelOptions(app.applicationId);
        const {form, configModalData} = this.props;
        // 清空渠道
        configModalData.aiUser = '';
        form.resetFields('channelCode');
      }
    }
  };

  // 点击取消
  cancel = () => {
    const {configModalData, setConfigModalVisible} = this.props;
    const {userStr} = this.state;
    // 还原ai应用和渠道
    configModalData.aiUser = userStr;
    setConfigModalVisible();
  };

  render() {
    const {
      configModalData: {
        id = '',
        strategyName = '',
        labelConfig = '',
        strategyLabelConfig = '',
        intro = '',
        addr = '',
        aiUser = '',
        config = '',
        publicKey = '',
        sceneId = '',
        channelId = '',
        nlpType = undefined,
      } = {},
      form: {resetFields, getFieldDecorator},
      aiAppOptions,
      appChannelOptions,
      yunwenChannels,
      yunwenScenes,
    } = this.props;
    const {confirmLoading, isShow} = this.state;
    const applicationCode = nlpType === 'ai' ? aiUser.split(',')[0] : '';
    const channelCode = nlpType === 'ai' ? aiUser.split(',')[1] : '';

    return (
      <ModalSize
        title={`${id ? '配置' : '新增'}话术`}
        // zIndex="1002"
        centered
        maskClosable={false}
        visible
        onOk={this.handleSubmit}
        onCancel={this.cancel}
        confirmLoading={confirmLoading}
        afterClose={() => {
          resetFields();
        }}>
        <Form>
          <FormItem {...formItemLayout} label="话术名称">
            {getFieldDecorator('strategyName', {
              initialValue: strategyName,
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: '话术名称不得为空！',
                },
              ],
            })(<Input placeholder="请输入话术名称" maxLength="64" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="NLP类型">
            {getFieldDecorator('nlpType', {
              initialValue: nlpType,
              rules: [
                {
                  required: true,
                  message: 'NLP类型不得为空！',
                },
              ],
            })(
              <Select
                placeholder="请选择NLP类型"
                onChange={this.handleSelectChange}>
                <Option value="gz">gz</Option>
                <Option value="af">af</Option>
                <Option value="yb">yb</Option>
                <Option value="ai">ai</Option>
                <Option value="sd">sd</Option>
                <Option value="yunwen">小云</Option>
              </Select>,
            )}
          </FormItem>
          {isShow === 'gz' ||
          isShow === 'af' ||
          isShow === 'yb' ||
          isShow === 'ai' ? (
            <FormItem {...formItemLayout} label="开场白命中词">
              {getFieldDecorator('intro', {
                initialValue: intro,
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: '开场白命中词不得为空！',
                  },
                ],
              })(
                <Input
                  disabled={isShow === 'ai'}
                  placeholder="请输入开场白命中词"
                />,
              )}
            </FormItem>
          ) : null}
          {isShow === 'gz' ||
          isShow === 'af' ||
          isShow === 'yb' ||
          isShow === 'ai' ? (
            <FormItem {...formItemLayout} label="AI登陆地址">
              {getFieldDecorator('addr', {
                initialValue: addr,
                rules: [
                  {
                    required: true,
                    message: 'AI登陆地址不得为空！',
                  },
                  {
                    // eslint-disable-next-line no-useless-escape
                    pattern: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                    message: 'AI登陆地址格式错误！',
                  },
                ],
              })(<Input placeholder="请输入AI登陆地址" />)}
            </FormItem>
          ) : null}
          {isShow === 'ai' ? (
            <FormItem {...formItemLayout} label="AI应用">
              {getFieldDecorator('applicationCode', {
                initialValue: applicationCode,
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: 'AI应用不得为空！',
                  },
                ],
              })(
                <Select
                  placeholder="请选择AI应用名称"
                  onChange={this.applicationChange}>
                  {aiAppOptions instanceof Array && aiAppOptions.length
                    ? aiAppOptions.map(
                        ({applicationName = '', applicationCode = ''}) => (
                          <Option key={applicationCode}>
                            {applicationName}
                          </Option>
                        ),
                      )
                    : null}
                </Select>,
              )}
            </FormItem>
          ) : null}
          {isShow === 'ai' ? (
            <FormItem {...formItemLayout} label="应用渠道">
              {getFieldDecorator('channelCode', {
                initialValue: channelCode,
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: '应用渠道不得为空！',
                  },
                ],
              })(
                <Select placeholder="请选择应用渠道名称">
                  {appChannelOptions instanceof Array &&
                  appChannelOptions.length
                    ? appChannelOptions.map(
                        ({channelName = '', channelCode = ''}) => (
                          <Option value={channelCode} key={channelCode}>
                            {channelName}
                          </Option>
                        ),
                      )
                    : null}
                </Select>,
              )}
            </FormItem>
          ) : null}
          {isShow === 'gz' || isShow === 'af' || isShow === 'yb' ? (
            <FormItem {...formItemLayout} label="AI用户名">
              {getFieldDecorator('user', {
                initialValue: aiUser,
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: 'AI用户名不得为空！',
                  },
                ],
              })(<Input placeholder="请输入AI用户名" />)}
            </FormItem>
          ) : null}
          {isShow === 'sd' ? (
            <FormItem {...formItemLayout} label="接口公钥">
              {getFieldDecorator('publicKey', {
                initialValue: publicKey,
                rules: [
                  {
                    required: true,
                    message: '接口公钥不得为空！',
                  },
                ],
              })(<Input placeholder="请输入接口公钥" />)}
            </FormItem>
          ) : null}
          {isShow === 'ai' || isShow === 'af' || isShow === 'gz' || isShow === 'yb' || isShow === 'sd' ? (
            <FormItem {...formItemLayout} label="AI端口地址">
              {getFieldDecorator('config', {
                initialValue: config,
                rules: [
                  {
                    required: true,
                    message: 'AI端口地址不得为空！',
                  },
                  {
                    // eslint-disable-next-line no-useless-escape
                    pattern: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                    message: 'AI端口地址格式错误！',
                  },
                ],
              })(<Input placeholder="请输入AI端口地址" />)}
            </FormItem>
          ) : null}
          {isShow === 'yunwen' ? (
              <FormItem {...formItemLayout} label="IVR渠道">
                {getFieldDecorator('channelId', {
                  initialValue: channelId,
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: 'IVR渠道不得为空！',
                    },
                  ],
                })(
                    <Select placeholder="请选择IVR渠道">
                      {yunwenChannels instanceof Array &&
                      yunwenChannels.length
                          ? yunwenChannels.map(
                              ({value = '', name = ''}) => (
                                  <Option value={value} key={value}>
                                    {name}
                                  </Option>
                              ),
                          )
                          : null}
                    </Select>,
                )}
              </FormItem>
          ) : null}
          {isShow === 'yunwen' ? (
              <FormItem {...formItemLayout} label="IVR场景">
                {getFieldDecorator('sceneId', {
                  initialValue: sceneId,
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: 'IVR场景不得为空！',
                    },
                  ],
                })(
                    <Select placeholder="请选择IVR场景">
                      {yunwenScenes instanceof Array &&
                      yunwenScenes.length
                          ? yunwenScenes.map(
                              ({value = '', name = ''}) => (
                                  <Option value={value} key={value}>
                                    {name}
                                  </Option>
                              ),
                          )
                          : null}
                    </Select>,
                )}
              </FormItem>
          ) : null}
          <FormItem {...formItemLayout} label="标签优先级">
            {getFieldDecorator('labelConfig', {
              initialValue: labelConfig,
              rules: [
                {
                  required: false,
                  whitespace: false,
                  message: '话术名称不得为空！',
                },
              ],
            })(<Input placeholder="请输入标签优先级" maxLength="1024" />)}
          </FormItem>
          {isShow === 'yunwen' ? (
              <FormItem {...formItemLayout} label="策略标签">
                {getFieldDecorator('strategyLabelConfig', {
                  initialValue: strategyLabelConfig,
                  rules: [
                    {
                      required: false,
                      whitespace: false,
                      message: '话术名称不得为空！',
                    },
                  ],
                })(<Input placeholder="请输入策略标签" maxLength="255" />)}
              </FormItem>
          ) : null}
        </Form>
      </ModalSize>
    );
  }
}
const mapStateToProps = ({systemSettingTalkingSkill}) => ({
  configModalData: systemSettingTalkingSkill.configModalData,
  pageStatus: systemSettingTalkingSkill.pageStatus,
  aiAppOptions: systemSettingTalkingSkill.aiAppOptions,
  appChannelOptions: systemSettingTalkingSkill.appChannelOptions,
  yunwenChannels: systemSettingTalkingSkill.yunwenChannels,
  yunwenScenes: systemSettingTalkingSkill.yunwenScenes,
});

const mapDispatchToProps = dispatch => ({
  talkingSkillActions: bindActionCreators(tTalkingSkillActions, dispatch),
});

const ConfigModalWrap = Form.create()(ConfigModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfigModalWrap);
